import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import Contractor from '../../components/people/contractor/Contractor'
import { getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'

import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import * as CommercialValidation from './CommercialValidation'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import Select from '../../libs/ui/inputs/Select'
import Input from '../../libs/ui/inputs/Input'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { CompleteValidationError } from '../../libs/validation/completeValidationError'
import { carPlateValidation } from '../../libs/validation/remoteValidationAbstract'
import { getTipiVeicoloCommerciale } from '../../libs/initialization/remoteInits'

import { CommercialPageProps, CommercialPageState, commercialPageInitialState, commercialhUpdate } from './CommercialPageSilce'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class CommercialPage extends BasePage<CommercialPageProps, CommercialPageState> {
    constructor (props: any) {
        super(props)

        this.state = {
            ...commercialPageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateTipoVeicolo = this.updateTipoVeicolo.bind(this)
        this.updateTarga = this.updateTarga.bind(this)
        this.updateNote = this.updateNote.bind(this)
        this.updateTipi_Veicolo = this.updateTipi_Veicolo.bind(this)

        this.step2Validation = this.step2Validation.bind(this)
        
        this.targaRegex = this.targaRegex.bind(this)
        this.noteRegex = this.noteRegex.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipi_veicolo === undefined) {
            getTipiVeicoloCommerciale(this.updateTipi_Veicolo, this.manageExpiredSessions)
        }
    }

    render(): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="commercial_vheicle_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={false}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <Select
                                                id='tipoVeicolo' name='tipoVeicolo' key='tipoVeicolo'
                                                label='Tipologia di mezzo' 
                                                value={this.state.tipoVeicolo}
                                                options={this.state.tipi_veicolo}
                                                callback={this.updateTipoVeicolo}
                                                error={this.state.tipoVeicoloError}
                                            />

                                            <Input 
                                                id='targa' name='targa' key='targa'
                                                label='Targa del veicolo' 
                                                value={this.state.targa}
                                                type='text'
                                                maxLength={10}
                                                callback={this.updateTarga}
                                                regexp={this.targaRegex}
                                                errorDisplayMsg='Targa non valida'
                                                remoteValidation={carPlateValidation}
                                                error={this.state.targaError}
                                            />

                                            <Input 
                                                id='note' name='note' key='note'
                                                label='Note (facoltativo)' 
                                                value={this.state.note}
                                                type='text'
                                                maxLength={100}
                                                minLength={3}
                                                callback={this.updateNote}
                                                regexp={this.noteRegex}
                                                errorDisplayMsg='Valore non valido'
                                                error={this.state.noteError}
                                            />
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    getInitialState() {
        return commercialPageInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ]).then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }
            
            return {
                errorString: e,
                pageError: p
            }
        }).catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        }
        else {
            let tipoVeicoloErro = undefined
            let targaErro = undefined
            let noteErro = undefined
            
            let global = undefined

            if ( errorString === 'TIPO_VEICOLO' ) {
                tipoVeicoloErro = 'Valore non valido / mancante'
                global = 'Indicare la tipologia di veicolo'
            }
            else if ( errorString === 'TARGA' ) {
                targaErro = 'Valore non valido / mancante'
                global = 'Inserire la targa del veicolo'
            }
            else if ( errorString === 'NOTE' ) {
                noteErro = 'Valore non valido / mancante'
                global = 'Compilare le note aggiuntive'
            }

            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                tipoVeicoloError: tipoVeicoloErro,
                targaError: targaErro,
                noteError: noteErro,
                
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            tipoVeicolo: this.state.tipoVeicolo ?? null,
            targa: this.state.targa ?? null,
            note: this.state.note ?? null,
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    commercialhUpdate (this.state)
                )
            }
        )
    }

    // -- solo del preventivatore
    private updateTipoVeicolo (val: string | undefined) {
        this.saveStateAndRedux({
            tipoVeicolo: val,
            tipoVeicoloError: undefined
        })
    }
    private updateTarga (val: string | undefined) {
        this.saveStateAndRedux({
            targa: val,
            targaError: undefined
        })
    }
    private updateNote (val: string | undefined) {
        this.saveStateAndRedux({
            note: (val === '') ? undefined : val,
            noteError: undefined
        })
    }

    private updateTipi_Veicolo (val: any) {
        this.setState({
            tipi_veicolo: val
        })
    }

    private step2Validation() {
        return CommercialValidation.page2Validation(
            this.state.altriSinistri,
            this.state.polizzaAttiva,
            this.state.scadenzaPolizza,
            this.state.tipoVeicolo,
            this.state.targa,
            this.state.note,
            getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
            this.state.user,
            this.printError,
            this.manageExpiredSessions
        )
    }

    private targaRegex () {
        return !CommercialValidation.isNotValidTarga(this.state.targa)
    }

    private noteRegex () {
        const note = this.state.note

        if (this.state.tipoVeicolo === 'altro') {
            return (
                note !== undefined &&
                note.length >= 3 && 
                note.length <= 100
            )
        }

        return true // nessun errore
    }

}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    tipoVeicolo: state.tipoVeicolo,
    targa: state.targa,
    note: state.note,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (CommercialPage)